export function wysiwygHeadings() {
    const classes = {
        H2: 'heading--m',
        H3: 'heading--s',
        H4: 'heading--xs',
        H5: 'heading--xs',
        H6: 'heading--xs',
    };

    document
        .querySelectorAll(
            '[data-text-content] h2, [data-text-content] h3, [data-text-content] h4, [data-text-content] h5, [data-text-content] h6'
        )
        .forEach((heading) => {
            heading.classList.add(classes[heading.tagName]);
        });
}